import { createRouter, createWebHistory } from 'vue-router'
import SearchView from '../views/SearchView'
import ResultsView from '../views/ResultsView'
import PhenotypeView from '../views/PhenotypeView'
import FavouritesView from '../views/FavouritesView.vue'
import NotFound from '../views/NotFound.vue'
import ForbiddenView from '../views/ForbiddenView.vue'
import LogoutView from '../views/LogoutView.vue'
import OidcCallback from '../views/OidcCallback.vue'
import OidcCallbackError from '../views/OidcCallbackError.vue'
import DonorDetailsView from '../views/DonorDetailsView.vue'
import CartView from '../views/CartView.vue'
import DashboardView from '../views/DashboardView.vue'
import CompareView from '../views/CompareView.vue'
import DashboardCoordinatorView from '../views/DashboardCoordinatorView.vue'
import DepositsComponent from '../components/DepositsComponent.vue'
import RedirectView from '../views/RedirectView.vue'
import BookingComponent from '../components/BookingComponent.vue'
import LegalComponent from '../components/LegalComponent.vue'
import TransportConditionsComponent from '../components/TransportConditionsComponent.vue'
import ReservationScreenView from '../views/ReservationScreenView.vue'
import OverviewComponent from '../components/OverviewComponent.vue'
import CoordinatorBookingComponent from '../components/Coordinator/BookingComponent.vue'
import CoordinatorGrantsComponent from '../components/Coordinator/GrantsComponent.vue'
import CoordinatorTransportOrderComponent from '@/components/Coordinator/OrderTransportComponent.vue'
import CompletePhenotypeViewVue from '@/views/CompletePhenotypeView.vue'
import ReservationPhenotypeView from '@/views/ReservationPhenotypeView.vue'
// import CalcView from '../views/CalcView.vue'
// import CalcDonorView from '../views/CalcDonorView.vue'
import ConfirmationView from '../views/ConfirmationView.vue'
import PaymentResultView from '../views/PaymentResultView.vue'

import store from '@/store'

const routes = [
  { 
    path: '/',
    name: 'search',
    component: SearchView,
    meta: {
      isPublic: true,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: LogoutView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/oidc-callback',
    name: 'oidcCallback',
    component: OidcCallback,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/oidc-callback-error',
    name: 'oidcCallbackError',
    component: OidcCallbackError,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/redirect/:mode/:pathname/:url?',
    name: 'redirect',
    component: RedirectView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/results',
    name: 'resultsView',
    component: ResultsView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/details/:materialType/:id',
    name: 'donorDetails',
    component: DonorDetailsView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/personal-details',
    name: 'overview',
    component: OverviewComponent,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/favourites',
    name: 'FavouritesView',
    component: FavouritesView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/phenotype',
    name: 'phenotypeView',
    component: PhenotypeView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/complete-phenotype/:type',
    name: 'completePhenotypeView',
    component: CompletePhenotypeViewVue,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/phenotype/:type',
    name: 'reservationPhenotypeView',
    component: ReservationPhenotypeView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/deposits',
    name: 'depositsComponent',
    component: DepositsComponent,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/reservations',
    name: 'bookingComponent',
    component: BookingComponent,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/legal-information',
    name: 'legalComponent',
    component: LegalComponent,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/transport-conditions',
    name: 'transportConditionsComponent',
    component: TransportConditionsComponent,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/cart',
    name: 'cartView',
    component: CartView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/confirmation',
    name: 'confirmationView',
    component: ConfirmationView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  // {
  //   path: '/kalkulator/dziecko',
  //   name: 'calcView',
  //   component: CalcView,
  //   meta: {
  //     isPublic: true,
  //     role: 'ROLE_PATIENT'
  //   }
  // },
  // {
  //   path: '/kalkulator/dawca',
  //   name: 'calcDonorView',
  //   component: CalcDonorView,
  //   meta: {
  //     isPublic: true,
  //     role: 'ROLE_PATIENT'
  //   }
  // },
  {
    path: '/book',
    name: 'reservationView',
    component: ReservationScreenView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/dashboard',
    name: 'dashboardView',
    component: DashboardView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/compare',
    name: 'compareView',
    component: CompareView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/payment-result',
    name: 'paymentResultView',
    component: PaymentResultView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT'
    }
  },
  {
    path: '/dashboard/coordinator',
    name: 'dashboardCoordinatorView',
    component: DashboardCoordinatorView,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT_COORDINATOR'
    }
  },
  {
    path: '/coordinator/reservations',
    name: 'coordinatorBookingComponent',
    component: CoordinatorBookingComponent,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT_COORDINATOR'
    }
  },
  {
    path: '/coordinator/grants',
    name: 'coordinatorGrantComponent',
    component: CoordinatorGrantsComponent,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT_COORDINATOR'
    }
  },
  {
    path: '/coordinator/transport-order',
    name: 'coordinatorTransportOrder',
    component: CoordinatorTransportOrderComponent,
    meta: {
      isPublic: false,
      role: 'ROLE_PATIENT_COORDINATOR'
    }
  },
  {
    path: "/error/403",
    name: 'forbidden',
    component: ForbiddenView,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/:catchAll(.*)",
    name: 'notFound',
    component: NotFound,
    meta: {
      isPublic: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const { role } = to.meta;
  const oidcUser = store.getters['oidcStore/oidcUser'];

  if (to.name == 'oidcCallback' && from.name) {
    next({ path: '/' })
  }

  if (to.name == 'oidcCallbackError' && from.name != 'oidcCallback') {
    next({ path: '/' })
  }

  store.dispatch('oidcStore/oidcCheckAccess', to).then(
    (hasAccess) => {
      if (hasAccess) {

        if (role && oidcUser) {
          if (oidcUser.roles.includes(role)) {
            next()
          } else if (oidcUser.roles.includes('ROLE_PATIENT_COORDINATOR') && to.path=='/') {
            next({ name: 'dashboardCoordinatorView' })
          } else {
            next({ name: 'forbidden' })
          }
        } else {
          next()
        }

      }
    }
  )

  if (from.query._locale && !to.query._locale) {
    let locale = from.query._locale
    let addedLocaleNext = {
      ...to,
      query: {
        ...to.query,
        _locale: locale,
      },
    }
    next(addedLocaleNext)
  }

});

export default router